module.exports = __webpack_public_path__ + "media/images/extension-onboarding/start-reading-d11fbfb7270be4ee9a5b18489896a40e.png";